<template>
    <div>
        <div class="tuijiebox" v-if="data.list.length>0">
            <div v-for="(c, index) in data.list" :key="index" :class="['item', c.more?'item_mn':'']">
<!--                <div v-for="(c, index) in data.list" :key="index" :class="['item ', (index > 4 && data.type === 2)?free_more_class_list[free_more_type]:'']">-->
                <div :class="['hd', c.isFree?'hd_f':'']">
                    <div class="ss" :style="{color:c.color}">{{ c.match_type }}</div>
                    <div class="time">{{ c.start }}</div>
                    <div class="cons" v-if="c.isConsume">已订</div>
                    <div class="pk" v-if="data.type === 2">
                        <em v-if="c.dxq">大小球</em><em v-else>让球</em>{{ c.pankou }}
                    </div>
                    <div class="ex" v-if="data.type === 3">
                        <a @click="toExpert(c.expert_e, index)">
<!--                        <router-link :to="'/expert/'+c.expert_e">-->
                            <div class="img"><img :src="c.expert_portrait"/><i v-if="c.expert_commend_num"></i></div>
                            <span class="t" v-if="c.expert_winning > 0">{{ c.expert }}</span>
                            <span class="t" v-else>{{ c.expert }}</span>
                            <span class="sl">{{c.expert_winning}}%</span>
<!--                        </router-link>-->
                        </a>
                    </div>
                    <div class="ex" v-else-if="data.type ===1 || data.type === 2">
                        <template v-if="data.type===1">
                            <router-link class="fe" :to="c.expert_group===1?'/football/dan':'/baskball/dan'">精选</router-link>
                        </template>
<!--                        <span class="fe" v-else>免费推介</span>-->
                    </div>
                </div>

                <template v-if="data.type === 2">
                    <div :class="'dz dz_f dz_f'+c.tjtype">
                        <div class="dzfcn">{{ c.shangpan }}<span class="bf" v-if="c.bifen !== '-'">{{c.bifen}}</span><span class="bf" v-else>VS</span>{{ c.xiapan }}</div>
                        <div class="result shengtx" v-if="c.tjtype === 2">公开时间：<div>{{c.public}}</div></div>
<!--                        <div class="result shengtx" v-if="c.tjtype === 2">公布：<div>{{c.sytime_text}}</div></div>-->
                        <div class="result deng" v-else-if="c.tjtype === 3">等待公开</div>
                        <div class="result rstj" v-else>
                            <div class="inge">
                            <div class="det"><span>荐</span>{{c.commend}}</div>
<!--                            <div class="jg"><span :class="'j'+c.result_id">{{ c.result }}</span></div>-->
                            </div>
                        </div>
                    </div>
                </template>
                <template v-else>
                <div class="dz">
                    <div class="lk" @click="toMatch(c.mid)">{{ c.shangpan }}<span class="bf" v-if="c.bifen !== '-'">{{c.bifen}}</span><span class="bf" v-else>VS</span>{{ c.xiapan }}</div>
                    <div class="pk" v-if="data.type !== 2">
                        <em v-if="c.dxq">大小球</em><em v-else>让球</em>{{ c.pankou }}
                    </div>
                </div>
                <div class="ds" v-if="data.type !== 2 && c.tjtype === 2">
                    <template v-if="c.dian0 !== c.dian">
                        <span class="od"><i>原售</i>{{ c.dian0 }}<em>FXB</em></span>
                        <span class="sj"><i>现售</i>{{ c.dian }}<em>FXB</em></span>
                    </template>
                    <span class="sj" v-else><i>现售</i>{{ c.dian }}<em>FXB</em></span>

                    <div class="jfdk"><i>积分抵扣</i><em>{{c.deduction}}%</em>({{c.deduction_amt}}<span>FXB</span>)</div>
                </div>

                <div class="bm">
<!--                    <template v-if="data.type===2">-->
<!--                        <div class="tj">-->
<!--                            <div class="shengtx" v-if="c.tjtype === 2">公布倒计时<div>{{c.sytime_text}}</div></div>-->
<!--                            <div class="deng" v-else-if="c.tjtype === 3">等待公开</div>-->
<!--&lt;!&ndash;                            <div class="det" v-else><span>荐</span>{{c.commend}}</div>&ndash;&gt;-->
<!--                        </div>-->
<!--                    </template>-->
<!--                    <template v-else>-->
                        <div class="tj" v-if="c.tjtype === 2">
                            <button class="dyn dyaddlj" @click="ding(c.mid)" v-if="c.dian === 0">免费订阅</button>
                            <button class="dyn dyaddlj" @click="ding(c.mid)" :data-id="c.mid" v-else>立即订阅</button>

                            <router-link to="/cart" class="cart" v-if="c.isCart"><span>已加购物车</span><em>进入购物车</em></router-link>
                            <button class="dyadd" @click="addCart(c.mid, index)" :data-id="c.mid" v-else>加入购物车</button>
                        </div>
                        <div class="tj" v-else-if="c.tjtype === 3">
                            <button class="dyn dydis">立即订阅</button>
                            <router-link to="/cart" v-if='c.isCart' class="cart"><span>已加购物车</span><em>进入购物车</em></router-link>
                            <button class="dydis" v-else>加入购物车</button>
                        </div>
                        <div class="tj" v-else>
                            <div @click="toMatch(c.mid)" class="det"><span>荐</span>{{ c.commend }}</div>
                        </div>
<!--                    </template>-->
                    <div class="jg"><span :class="'j'+c.result_id">{{ c.result }}</span></div>
                </div>
                </template>

                <div class="same" v-if="c.same_num" @click="matchMore(index, c.mid, c.source_id)">已隐藏<b>{{c.same_num}}</b>场预测方案<span>展开查看</span></div>
            </div>
<!--            <div :class="['panel_more', 'panel_more'+free_more_type]" v-if="data.type ===2 && data.list.length>5" @click="showMore">{{free_more_text_list[free_more_type]}}<i></i></div>-->

        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
export default {
    name: "match_mini",
    props: ['data'],
    computed: mapGetters(["dingSuccess", "showMoreFree"]),
    components: {
    },
    watch: {
        //监听订阅成功推介，实时更新
        dingSuccess(v){
            // console.log(v)
            this.data.list.forEach(function (c) {
                // if(v.indexOf(parseInt(c.mid))>-1)
                //     c.tjtype = 1
                v.forEach(function (e) {
                    if(e.mid === c.mid){
                        c.commend = e.commend
                        c.tjtype = 1
                    }
                })
            })
        },
    },
    data(){
        let _vm = this
        return {
            free_more_type: _vm.showMoreFree || 0,
            free_more_text_list: ['查看更多免费预测', '收起免费预测'],
            free_more_class_list: ['itemhide', ''],
            timer: null,
        }
    },
    created() {
        // console.log(this.free_more_type)
    },
    methods: {
        matchMore(index, mid, sid){
            // console.log(index, mid, sid)
            let that = this
            that.$toast.loading()
            that.$get(that.$api.match_list_more, {mid: mid, sid: sid})
                .then(function (res) {
                    // console.log(res)
                    if(res.code === 1) {
                        let old_list = that.data.list
                        old_list[index].same_num = 0
                        let new_list = res.data.list
                        new_list.forEach(function (c) {
                            c.more = true
                            c.same_num = 0
                        })
                        old_list.splice(index+1, 0, ...new_list)
                        that.$toast.clear()
                    }
                    else{
                        that.$toast.fail('fail~')
                    }
                })
                .catch(function () {
                    that.$toast.fail('fail~')
                })
                // .finally(function () {
                //
                // })
        },
        toExpert(name, index){
            this.data.list[index].expert_commend_num = 0
            this.$router.push('/expert/'+name)
        },
        toMatch(id){
            if(this.$route.name === 'match')
                this.$router.push('/match/'+id+'?'+new Date().getTime())
            else
                this.$router.push('/match/'+id)
        },
        showMore(){
          let that = this
            // console.log(localStorage.getItem('sfree') === '1')
          if(that.free_more_type === 1){
              that.free_more_type = 0
              that.$store.commit('setShowMoreFree', 0)
          }
          else{
              that.free_more_type = 1
              that.$store.commit('setShowMoreFree', 1)
          }
        },
        ding(id) {
            //let id = e.currentTarget.dataset.id
            let that = this
            // console.log(that.$store.state.user)
            // that.$store.commit('SET_DINGYUE', {'mid': id, 'commend': 'test'})
            that.$post(that.$api.dingyue, {mid: id}).then(function (res) {
                // console.log(res)
                if(res.code === 1){
                    that.$store.commit('SET_DING', res.data) //显示订阅弹窗确认，在App页里
                }
                else
                    that.$toast.fail(res.msg)
            })
        },
        addCart: function (mid, i) {
            let that = this
            that.$post(that.$api.addcart, {mid: mid}).then(function (res) {
                if(res.code === 1){
                    that.$toast.success(res.msg)

                    that.data.list[i].isCart = true
                    //更新存储数据
                    let userInfo = JSON.parse(localStorage.getItem('user'))
                    userInfo.cart += 1
                    that.$store.commit('SET_USER', userInfo)
                }
                else
                    that.$toast.fail(res.msg)
            })
        },
        /** 更新订阅剩余时间 */
        updateListDyStatus(){
            let that = this
            that.data.list.forEach(function (c) {
                if(c.tjtype === 2) {
                    c.sytime = c.sytime-1
                    if(c.sytime<=0) {
                        if(that.data.type === 2){ //免费推介
                            c.tjtype = 3
                            that.$get(that.$api.match_get, {mid: c.mid}).then(function (res) {
                                if(res.code === 1){
                                    c.commend = res.data.commend
                                    c.tjtype = 1
                                }
                            })
                        }
                        else
                            c.tjtype = 3 //等待公开
                        // clearInterval(that.timer)
                    }
                    c.sytime_text = that.$formatSeconds(c.sytime)
                    // console.log(c.sytime_text)
                }
                else{
                    c.sytime_text = '00:00:00'
                }
            })
        }
    },
    beforeDestroy() {
        clearInterval(this.timer)
        this.timer = null
    },
    mounted() {
        let that = this

        if(that.showMoreFree === 1) {
            that.free_more_type = 1
        }

        // that.timer = setInterval(()=>{
        //     // console.log(that.dingSuccess)
        //     that.updateListDyStatus() //定时更新订阅剩余时间
        // }, 1000)
    },
}
</script>

<style scoped>
</style>
